import Image from "next/legacy/image";
import Link from "next/link";
import routes from "@/lib/routes";
import styles from "@/styles/Title.module.scss";

export default function TitleDetailModal({ title }) {
  const channel = title?.channel;
  return (
    <div className={styles.detail}>
      <div className={styles.inner}>
        <h1 className={styles.title}>{title.name}</h1>
        <p className={styles.header}>{title.header}</p>
        <p>{title.description}</p>
        {title?.genres && (
          <div>{title.genres.map((genre) => genre.name).join("/")}</div>
        )}
        {title?.cast && <div>{title.cast}</div>}
        {title?.staff && <div>{title.staff}</div>}
        {title?.distributor && <div>{title.distributor}</div>}
        {title?.copyright && <div>{title.copyright}</div>}
      </div>
    </div>
  );
}
